<script setup lang="ts">
import {
  type FileContentFragmentFragment,
  FileContentTypeEnum,
} from '@/graphql/generated/graphql';
import JsonView from '@/ui/JsonView/JsonView.vue';
import JsonParse from '@/ui/JsonView/JsonParse.vue';

defineProps<{
  fileContent: FileContentFragmentFragment;
}>();
</script>

<template>
  <MDC v-if="fileContent.content_type === FileContentTypeEnum.Md" :value="fileContent.content" />
  <JsonParse v-else-if="fileContent.content_type === FileContentTypeEnum.Json" :json="fileContent.content">
    <template #default="{ json }">
      <JsonView :data="json" />
    </template>
  </JsonParse>
  <pre v-else>{{ fileContent.content }}</pre>
</template>